<template>
  <div class="popup-wrap">
    <div class="dimmed"/>
    <div class="popup-layer alert">
      <div class="popup-content">
        <div class="alert-msg">
          <strong v-if="title !== ''" class="msg-tit">{{ title }}</strong>
          <pre v-if="contents !== ''" class="msg-txt">{{ contents }}</pre>
        </div>
        <div v-if="!isAlert" class="popup-btn">
          <button v-if="cancelBtnNm !== ''" type="button" class="btn-type03" @click="$emit('close', false)"><span>{{ cancelBtnNm }}</span></button>
          <button type="button" class="btn-type02" @click="$emit('close', true)"><span>{{ okBtnNm }}</span></button>
        </div>
        <div v-else class="popup-btn">
          <button type="button" class="btn-type02" @click="$emit('close', true)"><span>{{ okBtnNm }}</span></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonAlertConfirm',
  props: {
    isAlert: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    contents: {
      type: String,
      default: ''
    },
    cancelBtnNm: {
      type: String,
      default: ''
    },
    okBtnNm: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    commonAlertConfirmAttrs () {
      return {
        ...this.componentAttrs,
        useDefaultHeader: false,
        useDefaultFooter: false,
        fullModal: false,
        mainclass: {
          'alert_type': this.isAlert
        }
      }
    }
  },
  /* vue lifecycle */
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  /* vue function */
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_common/wep-popup/WepAlertConfirmModal.vue